import type {PermissionLevels, PermissionTreeItem} from '../typedef';

type HasLevelPermission = (tree: PermissionTreeItem, level: PermissionLevels) => boolean;

export const hasLevelPermission: HasLevelPermission = (tree, level) => {
    if (tree.level === level) {
        return true;
    }

    if (tree.children) {
        return tree.children.some(child => hasLevelPermission(child, level));
    } else {
        return false;
    }
};
